import styled from 'styled-components';
import CollapseBody from './collapseBody';
import CollapseHeader from './collapseHeader';
import { colors } from '../colors';

interface collapseProps {
	margin?: string;
	padding?: string;
	show?: boolean;
}
const Collapse = styled.section<collapseProps>`
	display: inline-block;
	position: relative;
	box-sizing: border-box;
	width: 100%;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	border: 1px solid ${colors.Border2};
	background: ${colors.White};
	margin-bottom: 2px;
	
	${({ show }) =>
		show &&
		`${CollapseBody}{
			display: block;
		}
		${CollapseHeader}{
			border-bottom: 1px solid ${colors.GreyEC};
			padding-bottom: 15px;
			margin-bottom: 20px;
		}
	`};
	p {
		width: 100%;
	}
`;
export default Collapse;
